export const STATUS = {
  NONE: "none",
  APPROVED: "approved",
  REJECTED: "rejected",
  DOWNLOADED: "downloaded"
};

export default {
  STATUS
};



// WEBPACK FOOTER //
// /src/constants/constants.js